export default {"id":"48d1b2f6","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}